import { ROUTES } from "@/shared/constants/routes";
import { RouteObject } from "react-router-dom";
import TPRAHomePage from "../pages/home";
import TPRAVendorsPage from "../pages/vendors";
import TPRABreachHistoryPage from "../pages/breach-history";
import TPRAIssuesPage from "../pages/issues";
import TPRASessionsPage from "../pages/sessions";

export const ThirdPartyRiskRoutes: RouteObject[] = [
  {
    path: ROUTES.THIRD_PARTY_HOME,
    Component: TPRAHomePage,
  },
  {
    path: ROUTES.THIRD_PARTY_VENDORS,
    Component: TPRAVendorsPage,
  },
  {
    path: ROUTES.THIRD_PARTY_BREACH_HISTORY,
    Component: TPRABreachHistoryPage,
  },
  {
    path: ROUTES.THIRD_PARTY_ISSUES,
    Component: TPRAIssuesPage,
  },
  {
    path: ROUTES.THIRD_PARTY_SESSIONS,
    Component: TPRASessionsPage,
  },
];
